import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import ModalAlert from '~/components/modals/ModalAlert/ModalAlert.tsx';
import TaskAssigneeModal from './components/TaskAssigneeModal.tsx';
import TaskRoleFilter from './components/TaskRoleFilter.tsx';
import TasksServiceTable from './components/TasksServiceTable.tsx';
import { tasksPageText } from './constants.ts';
import { useGuaranteesTasksSection } from './hooks/useGuaranteesTasksSection.ts';
import { tasksPageStyles } from './styles.ts';

const MyTasksPage: React.FC = () => {
  const {
    assigneeModalProps,
    availableRoles,
    guaranteesTableProps,
    modalAlert,
    onModalAlertClose,
    roleFilterHandlers,
    selectedRole,
    tasksByService,
    visibleServices,
  } = useGuaranteesTasksSection();

  return (
    <Box sx={tasksPageStyles.pageWrap}>
      <Container maxWidth="xl" sx={tasksPageStyles.pageContainer}>
        <Box sx={tasksPageStyles.header}>
          <Typography variant="h4" sx={tasksPageStyles.title}>
            {tasksPageText.pageTitle}
          </Typography>
          <Typography variant="body2" sx={tasksPageStyles.subtitle}>
            {tasksPageText.pageSubtitle}
          </Typography>
        </Box>

        <Box sx={tasksPageStyles.contentGrid}>
          <Box sx={tasksPageStyles.roleColumn}>
            <TaskRoleFilter
              availableRoles={availableRoles}
              selectedRole={selectedRole}
              {...roleFilterHandlers}
            />
          </Box>

          <Box sx={tasksPageStyles.content}>
            {!availableRoles.length ? (
              <Box sx={tasksPageStyles.emptyState}>
                <Typography sx={tasksPageStyles.emptyTitle}>
                  {tasksPageText.emptyRolesTitle}
                </Typography>
                <Typography sx={tasksPageStyles.emptyText}>
                  {tasksPageText.emptyRolesText}
                </Typography>
              </Box>
            ) : !visibleServices.length ? (
              <Box sx={tasksPageStyles.emptyState}>
                <Typography sx={tasksPageStyles.emptyTitle}>
                  {tasksPageText.emptyFilteredTitle}
                </Typography>
                <Typography sx={tasksPageStyles.emptyText}>
                  {tasksPageText.emptyFilteredText}
                </Typography>
              </Box>
            ) : (
              visibleServices.map((serviceKey) => {
                const serviceTableProps = serviceKey === 'guarantees' ? guaranteesTableProps : {};

                return (
                  <TasksServiceTable
                    key={serviceKey}
                    serviceKey={serviceKey}
                    rows={tasksByService[serviceKey]}
                    {...serviceTableProps}
                  />
                );
              })
            )}
          </Box>
        </Box>
      </Container>
      <TaskAssigneeModal {...assigneeModalProps} />
      <ModalAlert
        isOpen={!!modalAlert.text}
        text={modalAlert.text}
        buttonValue={modalAlert.buttonValue}
        onClick={modalAlert.onClick}
        onClose={onModalAlertClose}
      />
    </Box>
  );
};

export default MyTasksPage;
